











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {AlertaCarga} from '@/model/resource/AlertaCarga'
import {AlertaCargaCollection} from '@/model/collection/AlertaCargaCollection'
import {ListAlertaCargaSchema} from '@/schema/resource/AlertaCarga/ListAlertaCargaSchema'
import {CsvAlertaCargaSchema} from '@/schema/resource/AlertaCarga/CsvAlertaCargaSchema'

@Component
export default class ListAlertaCargaView extends Mixins(MixinQueryRouter) {
  schema = new ListAlertaCargaSchema()
  collection = new AlertaCargaCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: AlertaCarga) {
    Helper.pushByName('editAlertaCarga', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new AlertaCargaCollection().clearFilters().addFilter(params)

    await csv.listCsvAlertaCarga()
    new CsvAlertaCargaSchema().downloadCsv(csv.all())
  }
}
